import type { ApiError } from '@/types/error';

export const NETWORK_SLOW_MESSAGE = 'The network is slow. Please try again.';

/** RTK Query reports a request that timed out or never got an answer like this. */
export const isNetworkError = (err: unknown) => {
  const status = (err as { status?: unknown } | undefined)?.status;
  return status === 'TIMEOUT_ERROR' || status === 'FETCH_ERROR';
};

/** Best message for an API error: the server's own text, the slow-network hint, or the fallback. */
export const getApiErrorMessage = (err: unknown, fallback: string) => {
  if (isNetworkError(err)) return NETWORK_SLOW_MESSAGE;
  const message = (err as ApiError | undefined)?.data?.message;
  if (Array.isArray(message)) return message[0] || fallback;
  return (message as string | undefined) || fallback;
};
